<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
    <vue-progress-bar></vue-progress-bar>
	<Footer></Footer>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapMutations, mapGetters } from 'vuex';
import Footer from '@/components/Footer'

export default {
	name: 'App',
	components:{
		Footer
	},
	beforeMount(){
		this.loadMe()
	},
	computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
	},
	methods:{
		...mapMutations(['logout']),
		loadMe(){
			// console.log('loadMe', this.isAuthenticated)
			if( this.isAuthenticated){
				this.$apollo.query({
					query: gql`query {
						me {
							id
							name
							email
							is_admin
						}
					}`,
					fetchPolicy: 'no-cache',
				})
				.then((data) => {
					// console.log('main LoadMe then', data)
					if(!data.data.me.is_admin){
						this.$router.push('/logout')	
					}
					// this.updateLogged(data.data.meMedic);
				})
				.catch(() => {
					// console.log('main LoadMe catch', data)
					this.$router.push('/logout')
				});
			}else{
				// console.log('main NOT authenticated')
				this.$router.push('/logout')
			}
		},
	}

}
</script>
